import { HttpEndpoint } from '@/api/httpEndpoints';
import { RootState } from '@/store/types';
import { isLocalHost } from '@/helpers/url';
import { configBase } from '@/config/base';
import { ErrorEndpoint as ErrorEndpointModel, JavascriptError } from './errors.interfaces';

export class ErrorEndpoint extends HttpEndpoint implements ErrorEndpointModel {
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public async PublishError(
        javascriptError: JavascriptError,
        state: RootState
    ): Promise<void> {
        if (configBase.devMode.enabled || isLocalHost()) {
            return;
        }

        const bookingState = JSON.stringify(state.cart);
        const error: JavascriptError = {
            ...javascriptError,
            customData: {
                bookingState,
            },
        };

        await this.post('mvc/Errors/Log', error);
    }
}

export class FakeErrorEndpoint implements ErrorEndpointModel {
    public async PublishError(javascriptError: JavascriptError): Promise<void> {
        console.log('PublishError: ', javascriptError);
        return;
    }
}
